/**
 * 알림 센터 목 데이터·읽음 상태 (상단 헤더 벨).
 * TODO(server): notifications RPC(목록·읽음 처리·실시간 푸시)로 교체 — 지금은
 * 고정 목 + localStorage 읽음 시각만.
 */

export type AppNotification = {
  id: string;
  kind: "mission" | "pull" | "season" | "system";
  title: string;
  /** 분 단위 상대시각 목 */
  minutesAgo: number;
  to: string;
};

export const MOCK_NOTIFICATIONS: AppNotification[] = [
  { id: "n1", kind: "mission", title: "Daily check-in reward ready to claim", minutesAgo: 12, to: "/profile/missions" },
  { id: "n2", kind: "pull", title: "Gold Vinyl #1 pulled from Hobby Box", minutesAgo: 47, to: "/cards/openai-gpt:gold_vinyl" },
  { id: "n3", kind: "season", title: "Season 1 snapshot schedule posted", minutesAgo: 180, to: "/season" },
  { id: "n4", kind: "system", title: "Buyback rate updated to 85%", minutesAgo: 1440, to: "/shop" },
];

const READ_KEY = "ty-notifications-read-at";

/** 마지막 열람 시각(ms) — 열람 이후 항목만 미읽음으로 계산. */
export function getReadAt(): number {
  try {
    return Number(localStorage.getItem(READ_KEY)) || 0;
  } catch {
    return 0;
  }
}

export function markAllRead(): void {
  try {
    localStorage.setItem(READ_KEY, String(Date.now()));
  } catch {
    /* storage 불가 환경 — 읽음 상태 없이 동작 */
  }
}

/** 미읽음 수 — 목에서는 생성 시각을 now-minutesAgo로 환산해 비교. */
export function unreadCount(now: number = Date.now()): number {
  const readAt = getReadAt();
  return MOCK_NOTIFICATIONS.filter((n) => now - n.minutesAgo * 60_000 > readAt).length;
}

export function relativeLabel(minutesAgo: number): string {
  if (minutesAgo < 60) return `${minutesAgo}m ago`;
  if (minutesAgo < 1440) return `${Math.floor(minutesAgo / 60)}h ago`;
  return `${Math.floor(minutesAgo / 1440)}d ago`;
}
